import React, { useEffect, useState, useMemo } from 'react';
import {
  Container,
  Typography,
  Button,
  Snackbar,
  Alert,
  Box,
  IconButton,
  Tooltip
} from '@mui/material';
import { Visibility, Edit, Delete, Add } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import axios from 'axios';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';


const API_URL = process.env.REACT_APP_API_URL;

export default function ClientesLista() {
  const [clientes, setClientes] = useState([]);
  const [snackbar, setSnackbar] = useState({ open: false, mensagem: '', tipo: 'success' });
  const navigate = useNavigate();

  useEffect(() => {
    fetchClientes();
  }, []);

  const fetchClientes = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_URL}/clientes`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setClientes(res.data);
    } catch {
      setSnackbar({ open: true, mensagem: 'Erro ao carregar clientes.', tipo: 'error' });
    }
  };

  const excluirCliente = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API_URL}/clientes/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSnackbar({ open: true, mensagem: 'Cliente excluído com sucesso!', tipo: 'success' });
      fetchClientes();
    } catch {
      setSnackbar({ open: true, mensagem: 'Erro ao excluir cliente.', tipo: 'error' });
    }
  };

  const columns = useMemo(() => [
    { accessorKey: 'id', header: 'ID', size: 60 },
    { accessorKey: 'nome', header: 'Nome', filterVariant: 'text' },
    { accessorKey: 'cpf_cnpj', header: 'CPF/CNPJ', filterVariant: 'text' },
    { accessorKey: 'telefone', header: 'Telefone', filterVariant: 'text' },
    { accessorKey: 'email', header: 'Email', filterVariant: 'text' },
    { accessorKey: 'uf', header: 'UF', filterVariant: 'select', filterSelectOptions: [
      "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA",
      "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN",
      "RS", "RO", "RR", "SC", "SP", "SE", "TO"
    ]},
    {
      id: 'acoes',
      header: 'Ações',
      Cell: ({ row }) => (
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Tooltip title="Visualizar">
            <IconButton onClick={() =>  navigate(`/cadastros/clientes/${row.original.uuid_cliente}/visualizar`)}>
              <Visibility sx={{ color: "#007bff" }} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Editar">
            <IconButton onClick={() => navigate(`/cadastros/clientes/${row.original.uuid_cliente}/editar`)}>
              <Edit sx={{ color: "#ed3237" }} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Excluir">
            <IconButton color="error" onClick={() => excluirCliente(row.original.uuid_cliente)}>
              <Delete />
            </IconButton>
          </Tooltip>
        </Box>
      )
    }
  ], [navigate]);

  const table = useMaterialReactTable({
    columns,
    data: clientes,
      localization: MRT_Localization_PT_BR, 

    enableColumnFilters: true,
    enableGlobalFilter: true,
    enablePagination: true,
    enableSorting: true,
    initialState: {
      pagination: { pageSize: 10, pageIndex: 0 },
    },
    muiTablePaperProps: {
      elevation: 3,
      sx: {
        borderRadius: 2,
        mt: 3
      }
    },
    muiTableContainerProps: {
      sx: {
        maxHeight: '65vh',
        overflowY: 'auto'
      }
    },
    muiTableHeadCellProps: {
      sx: {
        backgroundColor: "#f9f9f9",
        fontWeight: 'bold',
        color: '#333'
      }
    },
  });

  return (
    <Container maxWidth="" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h6" sx={{ mt: 5, mb: 3 }}>
        Clientes
      </Typography>

      <Button
        variant="contained"
        startIcon={<Add sx={{ color: '#ed3237' }} />}
        onClick={() => navigate('/cadastros/clientes/novo')}
        sx={{
          backgroundColor: "#3e4095",
          fontWeight: "bold",
          color: "#ffffff",
          "&:hover": {
            backgroundColor: "#333",
            boxShadow: "0 0 0 2px #ed3237 inset"
          }
        }}
      >
        Adicionar
      </Button>

      <MaterialReactTable table={table} />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.tipo} sx={{ width: "100%" }}>
          {snackbar.mensagem}
        </Alert>
      </Snackbar>
    </Container>
  );
}
